export let customizeStatusBar = "_VzLDe";
export let itemsInView = "SnQawd";
export let unreadItemsInView = "HhCeyd";
export let remindersMenuLabel = "ojrxte";
export let viewShortcutsMenuLabel = "LCuRYd";
export let normalView = "mWKZbc";
export let readingView = "PCqBie";
export let zoomSliderMenuLabel = "XOJRve";
export let itemsLabel = "QFnkfe";
export let itemsTooltip = "jNqFW";
export let unreadLabel = "F5R0eb";
export let unreadTooltip = "ykGOcd";
export let statusBarZoom = "stGMcb";
export let statusBarZoomIn = "xJEFYb";
export let statusBarZoomOut = "eHCAg";
export let statusBarZoomLevel = "_kgB1";
export default {customizeStatusBar,itemsInView,unreadItemsInView,remindersMenuLabel,viewShortcutsMenuLabel,normalView,readingView,zoomSliderMenuLabel,itemsLabel,itemsTooltip,unreadLabel,unreadTooltip,statusBarZoom,statusBarZoomIn,statusBarZoomOut,statusBarZoomLevel};